import styled from 'styled-components';
import { Link } from 'gatsby';
import { getMediaQuery } from '@carvana/showroom-theme';
import BodyTextBlock from '@carvana/showroom-content/TextBlock/Body';
import CaretRight from '../../../../../images/icons/caret-right.svg';

export const StyledResult = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.carvana.gray.light};
  list-style: none;
`;

export const StyledTruncatedContent = styled.span`
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 24px;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    width: 70%;
    max-width: 500px;
  }
`;

export const StyledTextBlock = styled(BodyTextBlock)`
  ${BodyTextBlock.Title} {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;

    ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
      font-size: 24px;
      line-height: 30px;
      font-weight: 400;
    }
  }

  ${BodyTextBlock.Description} {
    margin-bottom: 0;
    font-size: 14px;
    line-height: 24px;

    ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
      width: 70%;
      max-width: 500px;
    }
  }
`;

export const StyledTitle = styled(BodyTextBlock.Title)``;
export const StyledDescription = styled(BodyTextBlock.Description)``;

export const StyledIconRightCaret = styled(CaretRight)`
  width: 12px;
  height: 12px;
`;

export const StyledArrow = styled.div`
  text-align: right;
  color: ${({ theme }) => theme.carvana.blue.primary};
`;

// Update Styles mostly for Hover State
export const StyledLink = styled(Link)`
  display: block;
  padding: 1rem;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    padding: 1.625rem;
  }

  &:hover {
    text-decoration: none;
    background-color: ${({ theme }) => theme.carvana.gray.background};

    ${BodyTextBlock.Title} {
      color: ${({ theme }) => theme.carvana.stroke.blue};
    }
    ${StyledArrow} {
      color: ${({ theme }) => theme.carvana.blue.hover};
    }
  }
`;
